import i18next from "i18next";
import "./i18n/index";

const globalMenuItems = [
  {
    name: i18next.t("globalMenu.homePage"),
    icon: "global-menu-workspace",
    linkTo: "/",
  },
  {
    name: i18next.t("globalMenu.assets"),
    icon: "global-menu-taxes",
    linkTo: "/varad",
  },
  {
    name: i18next.t("globalMenu.procedures"),
    icon: "global-menu-customs",
    linkTo: "/menetlused",
  },
  {
    name: i18next.t("globalMenu.agreements"),
    icon: "global-menu-reporting",
    linkTo: "/lepingud",
  },
  {
    name: i18next.t("globalMenu.reports"),
    icon: "global-menu-registries",
    linkTo: "/aruanded",
  },
];
export const RealEstateUnitMenuItem = {
  name: i18next.t("globalMenu.realEstateUnit"),
  icon: "global-menu-clearing",
  linkTo: "/kinnisvarauksus",
};

export const NotificationsSubscriptionsMenuItem = {
  name: i18next.t("globalMenu.notificationsSubscriptions"),
  icon: "global-menu-help",
  linkTo: "/teavituste-tellimine",
};

export const AdministrationMenuItem = {
  name: i18next.t("globalMenu.administration"),
  icon: "global-menu-statistics",
  linkTo: "/administreerimine",
};

export default globalMenuItems;
